import type { CallerHandledAuthFailureOptions } from "@/utils/callerHandledAuthFailure"
import { getMyOrganizations } from "@/api/organization-scope"
import { getToken } from "@/utils/cache/cookies"
import { loadOrganizationsForCurrentSession } from "./manager"

export function fetchOrganizationContextForCurrentSession(
  options: CallerHandledAuthFailureOptions = {},
) {
  return loadOrganizationsForCurrentSession({
    getToken,
    loadOrganizations: async internalRequestOptions => {
      const res = await getMyOrganizations({
        ...options,
        ...internalRequestOptions,
      })
      return {
        organizations: res.data?.organizations ?? [],
        currentScope: res.data?.currentScope,
      }
    },
  })
}

export async function fetchOrganizationsForCurrentSession(
  options: CallerHandledAuthFailureOptions = {},
) {
  return (await fetchOrganizationContextForCurrentSession(options)).organizations
}
